export default __webpack_public_path__ + "static/media/03.00546cc7.jpg";